import { Grid, useMediaQuery } from "@mui/material";
import ScoreCard from "../Components/ScoreCard";
import {
  TAnalyticsTeacherOverview,
  THighlightObject,
} from "../../../models/analyticsmodel";
import Highlights from "../Components/Highlights";
import StatisticsBox from "../Components/TeacherStatisticsBox";

type TProps = {
  data: TAnalyticsTeacherOverview;
  highlights?: THighlightObject;
  selectedSectionName: string;
};

export default function TeacherAnalyticsOverview(props: TProps) {
  const isMobile = useMediaQuery("(max-width: 576px)");

  return (
    <div className="px-0">
      <div className="px-2 px-sm-4">
        <StatisticsBox
          title={"Summary"}
          data={props.data}
          selectedSectionName={props.selectedSectionName}
        />
      </div>

      <div className={"pb-4 mt-4 px-2 px-sm-4 " + (isMobile ? "mx-0" : "")}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            {props.highlights !== undefined ? (
              <Highlights highlights={props.highlights} />
            ) : (
              "No Highlights to show"
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            <ScoreCard isLoading={false} data={props.data} role="creator" />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
